import React from 'react';
import { motion } from 'framer-motion';

export default function Intro() {
  return (
    <section className="py-24 md:py-32 bg-maaich-black relative overflow-hidden">
      <div className="container mx-auto px-5 relative z-10">
        <div className="max-w-4xl mx-auto text-center md:text-left">
          <motion.h2 
            className="text-4xl md:text-6xl font-display uppercase italic mb-8 leading-[1.1]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            La tua impresa di sgomberi in tutta la <span className="text-maaich-lime">Lombardia nord</span>
          </motion.h2>
          
          <motion.div 
            className="text-lg md:text-xl text-white/70 font-body font-light leading-relaxed space-y-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <p>
              MAAICH Sgomberi è specializzata nello sgombero di appartamenti, case, cantine, solai, box, uffici, negozi e magazzini nelle province di <strong className="text-white">Varese, Como, Bergamo, Lecco e in tutta la Brianza</strong>. 
            </p>
            <p>
              Ci occupiamo di ogni fase: sopralluogo, rimozione di mobili ed elettrodomestici, trasporto e smaltimento in discariche autorizzate. Che si tratti di un trasloco, di un'eredità, della vendita di un immobile o di una ristrutturazione, liberiamo i tuoi spazi in poche ore, senza stress e senza sorprese sul prezzo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}